export default "__VITE_ASSET__CrIsPYCx__"